// extracted by mini-css-extract-plugin
module.exports = {"root":"p4IhE9","emptySpan":"U7wpuD"};